import {mapState, mapMutations} from 'vuex'
import {getLabel} from '@/utils/Institution'
import {subscribeToPrivateChannelEvents, leaveChannel} from "@/utils/Sockets";
import EventWatcherMixin from "@/mixins/EventWatcherMixin";


export default {
    mixins: [EventWatcherMixin],
    components: {
        ClientHistoryTitle: () => import('@/components/appointments/attention/ClientHistoryTitle'),
        AttentionSummary: () => import('@/components/appointments/attention/AttentionSummary')
    },
    data(){
        return {
            selectedEvent: null,
        }
    },
    mounted(){
        const vm = this
        vm.hideAttentionSummaryDrawer()
        vm.selectedEvent = JSON.parse(JSON.stringify(vm.currentEvent))
        vm.$nextTick(() => {
            vm.loadEventInfo()
        })
        //this.setEvent(null)
    },
    beforeDestroy(){
        const vm = this

        vm.setBackToEvent({
            show: true,
            event: JSON.parse(JSON.stringify(vm.currentEvent))
        })

        vm.$nextTick(function(){
            vm.setEvent(null)
            vm.disconnectFromDerivationSocket()
            vm.hideAttentionSummaryDrawer()
        })

    },
    computed:{
        ...mapState(['currentProvider']),
        ...mapState('clientAttention', {
                attentionSummaryDrawer: state => state.attentionSummaryDrawer,
                currentEvent: state => state.currentEvent
        }),
        hasAccessToDerivation(){
            const vm = this
            if(!vm.eventDetails) return false
            return vm.eventDetails.derived_from_event &&
                vm.eventDetails.derived_from_event.derivation &&
                vm.eventDetails.derived_from_event.derivation.specialist_id ?
                    Number(vm.eventDetails.derived_from_event.derivation.specialist_id) === vm.currentUser.id : false
        },
        derivationRoomName(){
            const vm  = this
            if(!vm.eventDetails) return ''
            return `appointment.${vm.eventDetails.id}.derivation`
        }
    },
    methods: {
        ...mapMutations([
                'showSnackBar',
                'showClientList',
                'hideClientList',
                'setBackToEvent'
            ]),
        ...mapMutations('clientAttention', [
                'setEvent',
                'setCurrentClient',
                'showAttentionSummaryDrawer',
                'hideAttentionSummaryDrawer'
            ]),
        onEventsChange(events) {
            this.$emit('change:events', events)
        },
        connectToDerivationSocket(){
          const vm = this
          if(!vm.derivationRoomName) return
          subscribeToPrivateChannelEvents(vm.derivationRoomName, {
              'DerivationCreated': vm.onDerivationCreated
          })
        },
        disconnectFromDerivationSocket(){
            const vm = this
            if(!vm.derivationRoomName) return
            leaveChannel(vm.derivationRoomName)
        },
        onDerivationCreated({derivation, derivedFromEvent}){
            const vm = this
            console.log('derivation created', derivation, derivedFromEvent)
            if(!vm.eventDetails) return
            let currentEvent = JSON.parse(JSON.stringify(vm.eventDetails))
            currentEvent.derived_from_event = derivedFromEvent
            vm.eventDetails = currentEvent
        },
        onDerivationUpdated(derivation){
            const vm = this
            console.log('derivation changed', derivation)
            if(!vm.eventDetails || !vm.eventDetails.derived_from_event) return
            let currentEvent = JSON.parse(JSON.stringify(vm.eventDetails))
            currentEvent.derived_from_event.derivation = derivation
            vm.eventDetails = currentEvent
        },
        getLabel,
        onStepsToFollowChange(val){
            const vm = this
            vm.eventDetails.steps = val
        },
        onClientEdit(client){
            var vm = this
            var evt = JSON.parse(JSON.stringify(vm.currentEvent))
            const isClient = evt.client.id === client.id

            if(isClient){
                evt.client = client
            }else{
                const companionIndex = evt.companions.findIndex(companion => companion.id === client.id)
                if(companionIndex !== -1){
                    evt.companions.splice(companionIndex, 1, client)
                }
            }

            vm.setEvent(evt)
        },
        onAttentionStart(event){
            var vm = this

            const evt = JSON.parse(JSON.stringify(event))
            vm.setEvent(evt)
        },
        onAttentionEnd(event){
            var vm = this
            vm.setEvent(null)
            vm.setCurrentClient(null)
            vm.hideAttentionSummaryDrawer()
        },
        onAppointmentCancel(event){
            var vm = this
            vm.setEvent(null)
            vm.setCurrentClient(null)
            vm.hideAttentionSummaryDrawer()
        },

        onMenuClick(id = ''){
            var vm = this

            switch(id){
                case 'clients_btn':
                    vm.showClientList()
                    break
            }

        }
    },

    watch: {
        derivationRoomName(val){
            const vm = this
            if(val){
                vm.disconnectFromDerivationSocket()
                vm.connectToDerivationSocket()
            }
        },
        eventDetails(evt){
            if(evt && evt.event_status_id === 4){
                this.showAttentionSummaryDrawer(evt)
            }else{
                this.hideAttentionSummaryDrawer()
            }
        },
        selectedEvent(val){},

    }
}
